<template>
  <div class="mine-page">
    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="user-avatar-wrapper">
        <img :src="user.avatar || defaultAvatar" alt="avatar" class="user-avatar" />
        <div class="vip-badge" v-if="user.vipLevel > 0">
          <i class="el-icon-medal"></i>
          VIP
        </div>
      </div>
      <div class="user-info">
        <h2 class="user-name">{{ user.name || '未登录' }}</h2>
        <div class="user-id" v-if="user.id">ID: {{ user.id }}</div>
      </div>
    </div>

    <!-- 会员信息突出展示 -->
    <div class="vip-section">
      <div class="vip-card" :class="getVipCardClass()">
        <div class="vip-icon">
          <i class="el-icon-medal"></i>
        </div>
        <div class="vip-content">
          <div class="vip-type">{{ getUserTypeLabel() }}</div>
          <div class="vip-expiry" v-if="user.vipExpiry">
            <i class="el-icon-time"></i>
            <span>到期时间：{{ user.vipExpiry }}</span>
          </div>
          <div class="vip-expiry permanent" v-else-if="user.vipLevel == 9">
            <i class="el-icon-success"></i>
            <span>永久有效</span>
          </div>
          <div class="vip-expiry" v-else>
            <i class="el-icon-warning"></i>
            <span>暂无会员</span>
          </div>
        </div>
        <div class="vip-action" v-if="isLoggedIn">
          <el-button type="warning" size="small" round @click="showVipDialog = true">
            <i class="el-icon-present"></i>
            兑换VIP
          </el-button>
        </div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section" v-if="isLoggedIn">
      <div class="menu-card">
        <div class="menu-item" @click="showPasswordDialog = true">
          <div class="menu-icon">
            <i class="el-icon-lock"></i>
          </div>
          <div class="menu-text">修改密码</div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
        <div class="menu-item" @click="showPurchaseDialog = true">
          <div class="menu-icon purchase">
            <i class="el-icon-shopping-cart-2"></i>
          </div>
          <div class="menu-text">购买卡密</div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
      </div>
    </div>

    <!-- 退出登录 -->
    <div class="logout-section" v-if="isLoggedIn">
      <el-button type="danger" round class="logout-btn" @click="handleLogout">
        <i class="el-icon-switch-button"></i>
        退出登录
      </el-button>
    </div>

    <!-- 未登录状态 -->
    <div class="login-section" v-if="!isLoggedIn">
      <el-button type="primary" round class="login-btn" @click="goLogin">
        <i class="el-icon-user"></i>
        立即登录
      </el-button>
    </div>

    <!-- VIP兑换弹窗 -->
    <el-dialog title="VIP卡密兑换" :visible.sync="showVipDialog" width="90%" class="dark-dialog">
      <el-form>
        <el-form-item label="卡密">
          <el-input v-model="cardId" placeholder="请输入VIP卡密"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showVipDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmVip">确定兑换</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="90%" class="dark-dialog">
      <el-form>
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定修改</el-button>
      </span>
    </el-dialog>

    <!-- 购买卡密弹窗 -->
    <el-dialog title="购买卡密" :visible.sync="showPurchaseDialog" width="90%" class="dark-dialog">
      <div v-loading="purchaseLoading" class="purchase-content">
        <div v-if="purchaseLinks.length === 0" class="empty-state">
          <i class="el-icon-info"></i>
          <p>暂无购买链接</p>
        </div>
        <div v-else class="purchase-links">
          <div
            v-for="(link, index) in purchaseLinks"
            :key="index"
            class="purchase-link-item"
            @click="openPurchaseLink(link.link)"
          >
            <div class="link-info">
              <h4>{{ link.name }}</h4>
              <p>{{ link.link }}</p>
            </div>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="showPurchaseDialog = false">关闭</el-button>
        <el-button type="primary" @click="refreshPurchaseLinks">刷新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cardExchange, changePassword, logout, getSettings } from "@/api";

export default {
  name: "Mine",
  data() {
    return {
      isLoggedIn: false,
      showVipDialog: false,
      showPasswordDialog: false,
      showPurchaseDialog: false,
      purchaseLoading: false,
      cardId: "",
      purchaseLinks: [],
      defaultAvatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cdefs%3E%3ClinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%233b82f6;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%2306b6d4;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='50' cy='50' r='50' fill='url(%23grad)' /%3E%3C/svg%3E",
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      user: {
        name: "",
        vipLevel: 0,
        vipExpiry: "",
        vipType: "",
        avatar: "",
        id: "",
      },
    };
  },

  mounted() {
    this.isLoggedIn = localStorage.getItem("token") ? true : false;
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem("userInfo")) || {};
    }
  },

  watch: {
    showPurchaseDialog(newVal) {
      if (newVal) {
        this.fetchPurchaseLinks();
      }
    },
  },

  methods: {
    getUserTypeLabel() {
      if (!this.isLoggedIn) {
        return "请先登录";
      }
      if (this.user.vipLevel == 0) {
        return "普通用户";
      }
      if (this.user.vipLevel == 9) {
        if (this.user.vipType === 'basic') {
          return "魔趣解析永久会员";
        } else if (this.user.vipType === 'premium') {
          return "全能高级永久会员";
        } else {
          return "永久会员";
        }
      }
      if (this.user.vipType === 'basic') {
        return "魔趣解析会员";
      } else if (this.user.vipType === 'premium') {
        return "全能高级会员";
      } else {
        return "会员用户";
      }
    },

    getVipCardClass() {
      if (!this.isLoggedIn || this.user.vipLevel == 0) {
        return 'normal';
      }
      if (this.user.vipType === 'premium') {
        return 'premium';
      }
      return 'basic';
    },

    async fetchPurchaseLinks() {
      this.purchaseLoading = true;
      try {
        const domain = location.host;
        const response = await getSettings({ domain });
        if (response.data.purchase_link.length) {
          this.purchaseLinks = response.data.purchase_link;
        } else {
          this.purchaseLinks = [];
          this.$message.error("暂无购买链接");
        }
      } catch (error) {
        console.error("获取购买链接失败:", error);
        this.$message.error("获取购买链接失败");
      } finally {
        this.purchaseLoading = false;
      }
    },

    refreshPurchaseLinks() {
      this.fetchPurchaseLinks();
    },

    openPurchaseLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    confirmVip() {
      if (!this.cardId) {
        this.$message.warning("请输入卡密");
        return;
      }

      cardExchange({ cardId: this.cardId })
        .then(() => {
          this.showVipDialog = false;
          this.$message.success("兑换成功");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.isLoggedIn = false;
          this.user = {};
          this.$router.push("/login");
          this.cardId = "";
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    confirmPassword() {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm;

      if (!oldPassword) {
        this.$message.error("原密码不能为空");
        return;
      }

      if (newPassword !== confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      if (oldPassword === newPassword) {
        this.$message.error("新密码不能与原密码相同");
        return;
      }

      changePassword(this.passwordForm)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("密码修改成功");
            this.showPasswordDialog = false;
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            this.isLoggedIn = false;
            this.user = {};
            this.$router.push("/login");
            this.passwordForm = {
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            };
          } else {
            this.$message.error(response.message);
          }
        })
        .catch((error) => {
          console.error("修改密码失败:", error);
          this.$message.error("修改密码失败");
        });
    },

    async handleLogout() {
      try {
        await logout();
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        this.isLoggedIn = false;
        this.user = {};
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },

    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dark-theme.scss";

.mine-page {
  min-height: calc(100vh - 126px);
  background: $dark;
  padding: 20px 16px;
  padding-bottom: 80px;
}

// 用户信息卡片
.user-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 16px;
}

.user-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
}

.user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(139, 92, 246, 0.3);
}

.vip-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  background: linear-gradient(135deg, #ffd700 0%, #ffaa00 100%);
  color: #1a1a2e;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  
  i {
    font-size: 10px;
  }
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.user-id {
  color: $slate-400;
  font-size: 12px;
}

// 会员信息卡片
.vip-section {
  margin-bottom: 16px;
}

.vip-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid;
  position: relative;
  overflow: hidden;
  
  &.normal {
    background: rgba(100, 116, 139, 0.1);
    border-color: rgba(100, 116, 139, 0.3);
    
    .vip-icon {
      background: rgba(100, 116, 139, 0.2);
      color: $slate-400;
    }
    
    .vip-type {
      color: $slate-300;
    }
  }
  
  &.basic {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(6, 182, 212, 0.1) 100%);
    border-color: rgba(59, 130, 246, 0.3);
    
    .vip-icon {
      background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
      color: white;
    }
    
    .vip-type {
      background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  &.premium {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 170, 0, 0.1) 100%);
    border-color: rgba(255, 215, 0, 0.3);
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(90deg, #ffd700 0%, #ffaa00 100%);
    }
    
    .vip-icon {
      background: linear-gradient(135deg, #ffd700 0%, #ffaa00 100%);
      color: #1a1a2e;
    }
    
    .vip-type {
      background: linear-gradient(135deg, #ffd700 0%, #ffaa00 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
}

.vip-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  i {
    font-size: 24px;
  }
}

.vip-content {
  flex: 1;
  min-width: 0;
}

.vip-type {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.vip-expiry {
  display: flex;
  align-items: center;
  gap: 6px;
  color: $slate-400;
  font-size: 13px;
  
  i {
    font-size: 14px;
  }
  
  &.permanent {
    color: #67c23a;
  }
}

.vip-action {
  flex-shrink: 0;
}

// 功能菜单
.menu-section {
  margin-bottom: 16px;
}

.menu-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  &:active {
    background: rgba(255, 255, 255, 0.05);
  }
}

.menu-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(139, 92, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  i {
    font-size: 20px;
    color: $primary;
  }
  
  &.purchase {
    background: rgba(103, 194, 58, 0.1);
    
    i {
      color: #67c23a;
    }
  }
}

.menu-text {
  flex: 1;
  color: $slate-200;
  font-size: 15px;
  font-weight: 500;
}

.menu-arrow {
  color: $slate-500;
  font-size: 16px;
}

// 退出登录
.logout-section {
  margin-top: 32px;
}

.logout-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
}

// 登录按钮
.login-section {
  margin-top: 32px;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: $gradient-primary;
  border: none;
}

// 弹窗内容
.purchase-content {
  min-height: 150px;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: $slate-400;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    display: block;
  }
}

.purchase-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.purchase-link-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:active {
    background: rgba(255, 255, 255, 0.1);
  }

  .link-info {
    flex: 1;
    min-width: 0;

    h4 {
      margin: 0 0 4px 0;
      color: white;
      font-size: 16px;
    }

    p {
      margin: 0;
      color: $slate-400;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  i {
    color: $slate-400;
    font-size: 18px;
  }
}

// Dark Dialog
:deep(.dark-dialog) {
  .el-dialog {
    background: $card;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
  }

  .el-dialog__header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .el-dialog__title {
    color: white;
  }

  .el-dialog__close {
    color: $slate-400;

    &:hover {
      color: white;
    }
  }

  .el-form-item__label {
    color: $slate-300;
  }

  .el-input__inner {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.1);
    color: white;

    &::placeholder {
      color: $slate-400;
    }
  }
}
</style>
